import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light text-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <h1 className="display-1 fw-bold text-dark">404</h1>
            <h2 className="fw-semibold mb-3 text-muted">Page Not Found</h2>
            <p className="text-muted mb-4">
              The page you’re looking for doesn’t exist or has been moved.
            </p>
            <Link to="/" className="btn btn-primary">
              Go to Vedalytics Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
